import { useState } from "react";
import { Heart, Play } from "lucide-react";
import { fileUrl } from "@/lib/api";

function RetryImg({ src, className }) {
  const [tries, setTries] = useState(0);
  const [hidden, setHidden] = useState(false);
  const onError = () => {
    if (tries >= 3) return setHidden(true);
    setTimeout(() => setTries((t) => t + 1), 1500 * 2 ** tries);
  };
  if (hidden) return null;
  return <img src={tries ? `${src}&r=${tries}` : src} alt="" loading="lazy" decoding="async" onError={onError} className={className} />;
}

export function MediaThumb({ item, onOpen }) {
  const ratio = item.width && item.height ? `${item.width} / ${item.height}` : item.type === "video" ? "16 / 9" : "4 / 5";
  return (
    <button onClick={onOpen} className="relative block w-full overflow-hidden rounded-xl bg-[#F3ECE1] group" style={{ aspectRatio: ratio }} data-testid={`media-thumb-${item.id}`}>
      {item.thumb_url ? (
        <RetryImg src={fileUrl(item.thumb_url)} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
      ) : item.type === "video" ? (
        <span className="absolute inset-0 grid place-items-center text-xs text-[#968E87]">Video</span>
      ) : (
        <span className="absolute inset-0 grid place-items-center text-xs text-[#968E87]">Obdelava …</span>
      )}
      {item.type === "video" && (
        <span className="absolute top-2 right-2 w-8 h-8 rounded-full bg-black/45 backdrop-blur grid place-items-center text-white"><Play size={14} fill="white" /></span>
      )}
    </button>
  );
}

export function MasonryCard({ item, onOpen, onHeart, onUploader, reactions = true }) {
  return (
    <div className="masonry-item mb-3 fade-up" data-testid="gallery-item">
      <MediaThumb item={item} onOpen={onOpen} />
      <div className="flex items-center justify-between gap-2 px-1 pt-1.5">
        <button onClick={() => onUploader?.(item.uploader_name)} className="text-[11px] sm:text-xs text-[#6C6560] truncate hover:text-[#B39264] text-left" data-testid="gallery-item-uploader">
          {item.type === "video" ? "Posnel" : "Fotografiral"}: <span className="text-[#231F20]">{item.uploader_name}</span>
        </button>
        {reactions && (
          <button onClick={() => onHeart?.(item)} className="flex items-center gap-1 text-xs shrink-0 px-1.5 py-1 rounded-full hover:bg-[#EADBCE]/50 transition-colors" data-testid="gallery-item-heart">
            <Heart size={15} className={item.liked ? "fill-[#C99A8E] text-[#C99A8E]" : "text-[#968E87]"} />
            <span>{item.hearts || 0}</span>
          </button>
        )}
      </div>
    </div>
  );
}
